import { InputAdornment, styled, TextField, TextFieldProps as MuiTextFieldProps, Box } from "@mui/material"
import { ComponentType, forwardRef, useMemo } from "react"
import { getTextFieldStyles } from "./styles"
import { Tooltip } from "../../DataDisplay/tooltip"
import { Icon } from "../../DataDisplay/Icons"

const ErrorBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    position: "absolute",
    fontSize: 10,
    width: "100%",
    padding: 2,
}))

const TextFieldComponent = forwardRef<HTMLInputElement, MuiTextFieldProps>((props, ref) => {
    const { helperText, error, InputProps, variant, required, type, label, ...rest } = props

    const endAdornment = useMemo(() => {
        return (
            <StyledInputAdornment position="end">
                {InputProps?.endAdornment}
                {error && (
                    <Tooltip title={helperText}>
                        <Icon name="alert_W_warning" className="CustomTextField-errorIcon" color="error" sx={{ cursor: "default" }} />
                    </Tooltip>
                )}
            </StyledInputAdornment>
        )
    }, [props.InputProps?.endAdornment, error])

    return (
        <TextField
            {...rest}
            helperText={helperText}
            ref={ref}
            variant={variant ?? "filled"}
            InputProps={{ ...InputProps, endAdornment }}
            error={error}
            type="text"
            label={
                label ? (
                    <>
                        {label}
                        {required && <span className="MuiInputLabel-asterisk">*</span>}
                    </>
                ) : undefined
            }
        />
    )
})

const StyledInputAdornment = styled(InputAdornment)({
    "&:empty": {
        display: "none",
    },
})

export const MuiTextField = styled(TextFieldComponent, {
    name: "CustomTextField",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
    // should be removed later on when errorHandling is removed from TextField
    shouldForwardProp: (prop) => prop !== "errorHandling",
})(getTextFieldStyles) as ComponentType<MuiTextFieldProps>
